/**
 * Presentation helpers for blog category badges.
 *
 * Post data itself lives in the MDX frontmatter under `content/blog/` and is
 * read via `getAllBlogPosts()`. This module deliberately holds no post list:
 * a second, hand-maintained copy of the posts drifted out of sync with the
 * MDX files and had no consumers.
 */

export type CategoryColor = 'blue' | 'purple' | 'pink';

export const categoryColorClasses: Record<CategoryColor, string> = {
  blue: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  purple: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
  pink: 'bg-pink-500/20 text-pink-400 border-pink-500/30',
};

export const categoryHoverClasses: Record<CategoryColor, string> = {
  blue: 'hover:shadow-blue-500/10 hover:border-blue-500/30',
  purple: 'hover:shadow-purple-500/10 hover:border-purple-500/30',
  pink: 'hover:shadow-pink-500/10 hover:border-pink-500/30',
};

export const categoryTextHoverClasses: Record<CategoryColor, string> = {
  blue: 'group-hover:text-blue-400',
  purple: 'group-hover:text-purple-400',
  pink: 'group-hover:text-pink-400',
};

export const categoryLinkClasses: Record<CategoryColor, string> = {
  blue: 'text-blue-400 hover:text-blue-300',
  purple: 'text-purple-400 hover:text-purple-300',
  pink: 'text-pink-400 hover:text-pink-300',
};
